<template>
    <div>
      <modal size="small">
          <div slot="header">Minute papillon...</div>
          <div slot="body">
              <spinner></spinner>
          </div>
          <div slot="footer" class="panel-footer" >
              <div class="row columns">
                  demande en cours de traitement
              </div>
          </div>
      </modal>
    </div>
</template>

<script>
import modal from './modal.vue'
import spinner from './spinner.vue'

export default {
  name: 'spinningModal',
  components: {
    modal,
    spinner
  },
  props: {
    'message': null
  },
  data () {
    return {
      showModal: false
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-mask {
  position:fixed
}
</style>



// WEBPACK FOOTER //
// spinning-modal.vue?2903c448